import { createFileRoute, redirect } from '@tanstack/react-router'

import { ROLES } from '@/entities/auth'
import { RequestPage } from '@/pages/request-page'

export const Route = createFileRoute('/_dashboard/requests/$id')({
    onEnter: ({ params }) => {
        document.title = `Taxoparkee | Заявка №${params.id}`
    },
    beforeLoad: ({ context }) => {
        if (!context.auth.hasAnyRole([ROLES.superManager, ROLES.recruiter])) {
            throw redirect({
                to: '/support',
            })
        }
    },
    component: RequestPage,
    loader: ({ params }) => ({
        crumb: `Заявка №${params.id}`,
    }),
})
